import { FilterOptions } from "../../documents/utils/types"

export interface ValidationProcessListFilters {
    date: { from: Date | "all", to: Date | "all" }
    statusOptions: FilterOptions[]
    myRoleOptions: FilterOptions[]
}

export function validationProcessFiltersToQueryString(data: ValidationProcessListFilters): string {
    const params = new URLSearchParams()
    const statuses = data.statusOptions.filter(option => option.selected)
    const roles = data.myRoleOptions.filter(option => option.selected)

    if (data.date.from !== "all" && data.date.to !== "all") {
        params.append("dateFrom", new Date(data.date.from).toISOString())
        params.append("dateTo", new Date(data.date.to).toISOString())
    }

    if (statuses.length !== 0) {
        params.append("statuses", statuses.map(option => option.uniqueName).join(","))
    }

    if (roles.length !== 0) {
        params.append("roles", roles.map(option => option.uniqueName).join(","))
    }

    return params.toString()
}